module.exports = __webpack_public_path__ + "img/eda-badge-background.628ef380.png";